import React, { createContext, useState, useEffect } from "react";

import en from "../i18n/en.json";
import ar from "../i18n/ar.json";

export const LocaleContext = createContext();

const languages = { en, ar };

export const LocaleProvider = ({ children }) => {
  const savedLang = localStorage.getItem("lang") || "en";

  const [lang, setLang] = useState(savedLang);

  const t = (key, params) => {
    let text = languages[lang][key] || key;

    if (!params) return text;

    return Object.entries(params).reduce((acc, [k, v]) => {
      return acc.replaceAll(`{{${k}}}`, v);
    }, text);
  };

  const changeLanguage = (lang) => {
    setLang(lang);

    localStorage.setItem("lang", lang);
  };

  useEffect(() => {
    const direction = lang === "ar" ? "rtl" : "ltr";

    document.documentElement.lang = lang;
    document.documentElement.dir = direction;

    /* if (direction === "rtl") {
      import("bootstrap-rtl/dist/css/bootstrap-rtl.min.css");
    } else {
      import("bootstrap/dist/css/bootstrap.min.css");
    }*/
  }, [lang]);

  return (
    <LocaleContext.Provider
      value={{
        lang,
        changeLanguage,
        t,
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
};
